import type { IconButtonProps } from '@rjsf/utils'
import { Mtds, PlusIcon } from 'prove-common'

export const AddButton = ({ onClick, disabled }: IconButtonProps) => (
  <Mtds.Button
    className='mt-4'
    data-variant='secondary'
    disabled={disabled}
    onClick={onClick}
  >
    <PlusIcon />
    Legg til delprøve
  </Mtds.Button>
)
